import React from 'react';
import { IIconProps } from './utils';

export const Benchmark = ({
  fill = 'currentColor', height = 16, width = 16, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 16 16"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M3.92975 10.1407L5.40358 7.19299M3.92975 10.1407C3.75029 10.0508 3.54772 10.0002 3.33333 10.0002C2.59695 10.0002 2 10.5971 2 11.3335C2 12.0699 2.59695 12.6668 3.33333 12.6668C4.06971 12.6668 4.66667 12.0699 4.66667 11.3335C4.66667 10.8115 4.3667 10.3596 3.92975 10.1407ZM5.40358 7.19299C5.58305 7.2829 5.78561 7.3335 6 7.3335C6.37548 7.3335 6.7147 7.17829 6.95703 6.92854M5.40358 7.19299C4.96663 6.97409 4.66667 6.52216 4.66667 6.00016C4.66667 5.26378 5.26362 4.66683 6 4.66683C6.73638 4.66683 7.33333 5.26378 7.33333 6.00016C7.33333 6.36107 7.18994 6.68848 6.95703 6.92854M10.5964 8.80733L12.0703 5.85966M10.5964 8.80733C10.417 8.71743 10.2144 8.66683 10 8.66683C9.62452 8.66683 9.2853 8.82204 9.04297 9.07179M10.5964 8.80733C11.0334 9.02624 11.3333 9.47817 11.3333 10.0002C11.3333 10.7365 10.7364 11.3335 10 11.3335C9.26362 11.3335 8.66667 10.7365 8.66667 10.0002C8.66667 9.63926 8.81006 9.31185 9.04297 9.07179M12.0703 5.85966C12.2497 5.94957 12.4523 6.00016 12.6667 6.00016C13.403 6.00016 14 5.40321 14 4.66683C14 3.93045 13.403 3.3335 12.6667 3.3335C11.9303 3.3335 11.3333 3.93045 11.3333 4.66683C11.3333 5.18882 11.6333 5.64076 12.0703 5.85966ZM6.95703 6.92854L9.04297 9.07179"
      stroke={fill}
      strokeWidth="1.33333"
    />
  </svg>
);
